export default __webpack_public_path__ + "static/media/ShowHide.bd78ac70.svg";